import { useTranslation } from 'react-i18next';
import { IN_GAME_BBG_LOGO } from '../lib/tokenLogos';

type BubbleGameUniverseModalProps = {
  isOpen: boolean;
  bubbleGameLink: string | null;
  onClose: () => void;
};

export default function BubbleGameUniverseModal({
  isOpen,
  bubbleGameLink,
  onClose,
}: BubbleGameUniverseModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="bubble-game-universe-modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('bubbleGame.title')}
      >
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('bubbleGame.close')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="bubble-game-universe-identity">
            <img className="bubble-game-universe-logo" src={IN_GAME_BBG_LOGO} alt="Bubble Game logo" />
            <strong>{t('bubbleGame.tokenName')}</strong>
          </div>
          <p className="bubble-game-universe-description">{t('bubbleGame.description')}</p>
          {bubbleGameLink ? (
            <a className="auth-button bubble-game-enter-button" href={bubbleGameLink}>
              {t('bubbleGame.enterGame')}
            </a>
          ) : (
            <p className="bubble-game-deep-link-unavailable">{t('bubbleGame.deepLinkNotConfigured')}</p>
          )}
        </div>
      </section>
    </div>
  );
}
